<script>
import Layout from "../../../../../layouts/main";
import PageHeader from "@/components/page-header";
import { WarehousePath, LocationPath, WareHouseStock } from "@/path.js";
import AddStockToWarehouse from "./add.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
    add: AddStockToWarehouse,
  },
  data() {
    return {
      title: "Production",
      items: [
        {
          text: "List",
        },
        {
          text: "WarehouseStock",
          active: true,
        },
      ],
      fields: [
        "warehouse",
        "location",
        "date_of_inspection",
        "no_gravies_inspected",
        "no_packagings_inspected",
        "status",
        "action",
      ],
      inspectionDataType: "",
      list_items: [],
      cdn: process.env.VUE_APP_AWS_CDN,
      forms: {
        type: null,
        batch_code: null,
        warehouse_id: null,
        location_id: null,
        production_on: null,
      },
      currentPage: 1,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      try {
        let res = await axios.get(this.baseUrl + WareHouseStock.GET_LIST, {
          params: {
            status: this.inspectionDataType,
            page: this.currentPage,
          },
        });

        if (res.data.status) {
          this.list_items = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    addStockToWarehouse() {
      this.$bvModal.show("add-stock-to-warehouse");
    },
    async moveListToUpdated(v) {
      try {
        let res = await axios.post(
          this.baseUrl + WareHouseStock.MOVE_TO_INSPECTED,
          {
            inspection_id: v.inspection_id,
          }
        );
        if (res.data.status) {
          Swal.fire("Success", "Moved to updated", "", "success");
          this.reload();
        }
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "Failed to move list to upated", "", "error");
      }
    },
    async generateReport(v) {
      try {
        let res = await axios.get(
          this.baseUrl + WareHouseStock.GENERATE_REPORT,
          {
            params: {
              inspection_id: v.inspection_id,
              date_of_inspection: v.date_of_inspection.split(" ")[0],
            },
          }
        );

        if (res.data.status) {
          const reportUrl = this.cdn + "/" + res.data.data;
          const downloadLink = document.createElement("a");
          downloadLink.href = reportUrl;
          downloadLink.download = "report.xlsx";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      } catch (e) {
        console.log(e);
      }
    },
    reload() {
      this.getList();
    },
  },
  watch: {
    inspectionDataType() {
      this.getList();
    },
    currentPage() {
      this.getList();
    },
  },
  computed: {
    WarehousePath() {
      return WarehousePath;
    },
    LocationPath() {
      return LocationPath;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-header>
        <b-button variant="primary" @click="addStockToWarehouse"
          >Add Stock to Warehouse</b-button
        ></b-card-header
      >
      <b-modal id="add-stock-to-warehouse" size="xl" hide-footer>
        <add @reload="reload"></add>
      </b-modal>
      <b-tabs content-class="overflow-x-auto" nav-wrapper-class="no-wrap-tabs">
        <b-tab title="All" @click="inspectionDataType = ''"></b-tab>
        <b-tab title="Pending" @click="inspectionDataType = 'pending'"></b-tab>
        <b-tab title="Updated" @click="inspectionDataType = 'updated'"></b-tab
      ></b-tabs>
      <b-table :fields="fields" :items="list_items.data">
        <template v-slot:cell(warehouse)="row">
          <p>{{ row.item.warehouse.name }}</p>
        </template>
        <template v-slot:cell(location)="row">
          <p>{{ row.item.location.location }}</p>
        </template>
        <template v-slot:cell(date_of_inspection)="row">
          <p>{{ row.item.date_of_inspection }}</p>
        </template>
        <template v-slot:cell(no_gravies_inspected)="row">
          <p>{{ row.item.no_gravies_inspected }}</p>
        </template>
        <template v-slot:cell(no_packagings_inspected)="row">{{
          row.item.no_packagings_inspected
        }}</template>
        <template v-slot:cell(status)="row">
          <b-button
            :variant="row.item.status == 'pending' ? 'secondary' : 'success'"
            >{{ row.item.status }}
          </b-button>
        </template>
        <template v-slot:cell(action)="row">
          <div style="margin-bottom: 2px">
            <b-button
              v-if="row.item.status == 'pending'"
              @click="moveListToUpdated(row.item)"
              variant="success"
            >
              Move to Updated
            </b-button>
          </div>
          <div>
            <b-button @click="generateReport(row.item)" variant="success">
              Download Report
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul
              class="pagination pagination-rounded"
              style="margin-top: 0px !important"
            >
              <!-- pagination -->
              <b-pagination
                :key="list_items.key"
                v-model="currentPage"
                :total-rows="list_items.total"
                :per-page="list_items.per_page"
                class="dataTables_paginate"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>

<style></style>
